const menu = () => [
    {
        title: '信息管理',
        children_count: '3',
        id: 'menu_one',
        css: 'public_left_li menu_close',
        a_css: 'close',
        before: 'icon icon-note',
        after: 'public_left_close',
        status: 0,
        children: [
            {
                title: '医院列表',
                href: '/hospitals',
                active: false
            },
            {
                title: 'APP管理',
                href: '/app_types',
                active: false
            },
            {
                title: '销售员',
                href: '/agents',
                active: false
            }
        ]
    }, {
        title: 'EDGE管理',
        children_count: '4',
        id: 'menu_two',
        css: 'public_left_li menu_close',
        a_css: 'close',
        before: 'icon icon-tag',
        after: 'public_left_close',
        status: 0,
        children: [
            {
                title: '分页列表',
                href: '/edges',
                active: false
            },
            {
                title: '全部列表',
                href: '/all_edges',
                active: false
            },
            {
                title: '序列列表',
                href: '/serials',
                active: false
            },
            {
                title: 'mac追溯',
                href: '/pcs',
                active: false
            }
        ]
    }, {
        title: '续费提醒',
        children_count: '1',
        id: 'menu_three',
        css: 'public_left_li menu_close',
        a_css: 'close',
        before: 'icon icon-list',
        after: 'public_left_close',
        status: 0,
        children: [
            {
                title: '续费提醒',
                href: '/edge_exp',
                active: false
            }
        ]
    }, {
        title: '证书管理',
        children_count: '3',
        id: 'menu_four',
        css: 'public_left_li menu_close',
        a_css: 'close',
        before: 'icon icon-key',
        after: 'public_left_close',
        status: 0,
        children: [
            {
                title: '证书列表',
                href: '/licenses',
                active: false
            },
            {
                title: '证书上传',
                href: '/lic_upload',
                active: false
            },
            {
                title: '证书生成',
                href: '/lic_generate',
                active: false
            }
        ]
    }, {
        title: '申请管理',
        children_count: '4',
        id: 'menu_five',
        css: 'public_left_li menu_close',
        a_css: 'close',
        before: 'icon icon-handbag',
        after: 'public_left_close',
        status: 0,
        children: [
            {
                title: '证书申请',
                href: '/license_apply',
                active: false
            },
            {
                title: '待处理',
                href: '/applies',
                active: false
            },
            {
                title: '已处理',
                href: '/applies_done',
                active: false
            },
            {
                title: '周报',
                href: '/lic_notice',
                active: false
            }
        ]
    }, {
        title: '任务管理',
        children_count: '2',
        id: 'menu_six',
        css: 'public_left_li menu_close',
        a_css: 'close',
        before: 'icon icon-plane',
        after: 'public_left_close',
        status: 0,
        children: [
            {
                title: '执行任务',
                href: '/task_run',
                active: false
            },
            {
                title: '小工具',
                href: '/tool_kit',
                active: false
            }
        ]
    }, {
        title: '库存管理',
        children_count: '1',
        id: 'menu_seven',
        css: 'public_left_li menu_close',
        a_css: 'close',
        before: 'icon icon-support',
        after: 'public_left_close',
        status: 0,
        children: [
            {
                title: '总台账',
                href: '/batch_list',
                active: false
            }
        ]
    },
    // {
    //     title: '报销申请',
    //     children_count: '2',
    //     id: 'menu_seven',
    //     css: 'public_left_li menu_close',
    //     a_css: 'close',
    //     before: 'icon icon-support',
    //     after: 'public_left_close',
    //     status: 0,
    //     children: [
    //         {
    //             title: '报销申请',
    //             href: '/jump',
    //             active: false
    //         },
    //         {
    //             title: '我的申请',
    //             href: '/expense_person',
    //             active: false
    //         }
    //     ]
    // }, 
    // {
    //     title: '报销管理',
    //     children_count: '6',
    //     id: 'menu_eight',
    //     css: 'public_left_li menu_close',
    //     a_css: 'close',
    //     before: 'icon icon-wallet',
    //     after: 'public_left_close',
    //     status: 0,
    //     children: [
    //         {
    //             title: '待审批',
    //             href: '/expense_wait',
    //             active: false
    //         },
    //         {
    //             title: '待核销',
    //             href: '/expense_ready',
    //             active: false
    //         },
    //         {
    //             title: '未通过',
    //             href: '/expense_reject',
    //             active: false
    //         },
    //         {
    //             title: '已核销',
    //             href: '/expense_done',
    //             active: false
    //         },
    //         {
    //             title: '汇总报表',
    //             href: '/exp_report_all',
    //             active: false
    //         },
    //         {
    //             title: '明细报表',
    //             href: '/exp_report_detail',
    //             active: false
    //         }
    //     ]
    // }, 
    {
        title: '系统日志',
        children_count: '1',
        id: 'menu_eight',
        css: 'public_left_li menu_close',
        a_css: 'close',
        before: 'icon icon-info',
        after: 'public_left_close',
        status: 0,
        children: [
            {
                title: '日志记录',
                href: '/logs',
                active: false
            }
        ]
    }, {
        title: '账号管理',
        children_count: '1',
        id: 'menu_nine',
        css: 'public_left_li menu_close',
        a_css: 'close',
        before: 'icon icon-lock',
        after: 'public_left_close',
        status: 0,
        children: [
            {
                title: '修改密码',
                href: '/pwd',
                active: false
            }
        ]
    }
]

export default menu